import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getDeviceId, getDeviceType } from '@/pages/login/helpers';
import { userApis } from '../apis/user';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

onMessage(messaging, (payload: any) => {
  console.log('=================== Message received. ', payload);
});

const requestNotificationPermission = async () => {
  if ('serviceWorker' in navigator) {
    Notification.requestPermission().then(async (permission) => {
      if (permission === 'granted') {
        getToken(messaging, {
          vapidKey,
        }).then((fcmToken) => {
          if (fcmToken) {
            userApis.postFCMToken({
              device_id: getDeviceId(),
              device_type: getDeviceType(),
              push_token: fcmToken || '',
            });
          }
        });
      }
      if (permission === 'denied') {
        console.error('Notification permission denied');
        // Notification.requestPermission().then((permission) => {
        //   if (permission === 'granted') {
        //     requestNotificationPermission();
        //   }
        // });
      }
    });
  }
};

export { requestNotificationPermission };
